import React from 'react';
import { Typography, Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Chip } from '@mui/material';

const DetailsComponent = ({ details }) => {
  return (
    <div style={{ padding: '20px'}}>
      
      <Typography variant="h6" gutterBottom style={{ marginTop: '20px' }}>
        Basic Details
      </Typography>

      <TableContainer component={Paper}>
      <Table>
      
        <TableBody>
          <TableRow>
            <TableCell align="left">Name of Foreign Principal:</TableCell>
            <TableCell align="left">{details.nameOfForeignPrincipal}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="left">SLBFE Approval Number:</TableCell>
            <TableCell align="left">{details.SLBFEApprovalNumber}</TableCell>
          </TableRow>
          {/* <TableRow>
            <TableCell align="left">SLBFE Approved Charge:</TableCell>
            <TableCell align="left">{details.SLBFEApprovedCharge}</TableCell>
          </TableRow> */}
          <TableRow>
            <TableCell align="left">Accommodation:</TableCell>
            <TableCell align="left">{details.accommodation ? 'Yes' : 'No'}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="left">Address:</TableCell>
            <TableCell align="left">{details.address}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="left">Air Tickets Joining:</TableCell>
            <TableCell align="left">{details.airTicketsJoining ? 'Yes' : 'No'}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="left">Air Tickets Annual:</TableCell>
            <TableCell align="left">{details.airTicketsAnnual ? 'Yes' : 'No'}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="left">Contract Period:</TableCell>
            <TableCell align="left">{details.availabilityPeriod}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="left">Country:</TableCell>
            <TableCell align="left">{details.country}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="left">Email:</TableCell>
            <TableCell align="left">{details.email}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="left">Food:</TableCell>
            <TableCell align="left">{details.food ? 'Yes' : 'No'}</TableCell>
          </TableRow>
          {/* <TableRow>
            <TableCell align="left">Job Description:</TableCell>
            <TableCell align="left">{details.jobDescription}</TableCell>
          </TableRow> */}
          <TableRow>
            <TableCell align="left">Medical:</TableCell>
            <TableCell align="left">{details.medical ? 'Yes' : 'No'}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="left">Phone:</TableCell>
            <TableCell align="left">{details.phone}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="left">Weekly Working Hours:</TableCell>
            <TableCell align="left">{details.weeklyWorkingHours}</TableCell>
          </TableRow>
        
          <TableRow>
            <TableCell align="left">Working Hours:</TableCell>
            <TableCell align="left">{details.workingHours}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="left">Commission:</TableCell>
            <TableCell align="left">
              <Chip label={details.commission ? 'Added' : 'No Commission'} />
            </TableCell>
          </TableRow>
          {details?.commission && (
            <TableRow>
              <TableCell align="left">Commission From Client:</TableCell>
              <TableCell align="left">{details.commissionFromClient}</TableCell>
            </TableRow>
          )}
          {details?.commission && (
            <TableRow>
              <TableCell align="left">Commission To Client:</TableCell>
              <TableCell align="left">{details.commissionToClient}</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>

      {/* ... other details */}
      
      {/* Professions Table */}
      <Typography variant="h6" gutterBottom style={{ marginTop: '20px' }}>
        Professions
      </Typography>
      <TableContainer component={Paper} style={{ marginTop: '10px' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Serial Number</TableCell>
              <TableCell>Salary</TableCell>
              <TableCell>Currency</TableCell>
              <TableCell>Vacancies</TableCell>
              <TableCell>Job Category</TableCell>
              <TableCell>SLBFE Chargeable Amount</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {details.professions.map((profession) => (
              <TableRow key={profession.serialNumber}>
                <TableCell>{profession.serialNumber}</TableCell>
                <TableCell>{profession.salary}</TableCell>
                <TableCell>{profession.currency}</TableCell>
                <TableCell>{profession.vacancies}</TableCell>
                <TableCell>{profession.jobCategory}</TableCell>
                <TableCell>{profession.fee}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default DetailsComponent;
